<td>
  <a uiSref="a.business_order.view" [uiParams]="{id:ba.id, index:ba.index}">
    {{ ba.id }}-{{ ba.index }} / {{ ba.count }}
  </a>
  <div>
    <business-order-label [surface]="ba.surface"
                          [empb]="!!ba.empb && !!ba.first_contract"
                          [kanban]="ba.kanban"
                          [hasPlugging]="ba.has_plugging"
                          [hasCopperFilling]="ba.has_copper_filling"
                          [hasReproduction]="!!ba.reproduction"
                          [willBeMerged]="!!ba.reproduction?.will_be_merged ||
                               ((ba.reproduction?.step_ordering ?? null) !== null)"
                          [hasBlindHole]="ba.has_blind_hole"
                          [isT3]="ba.is_t3"
                          [isT6]="ba.is_t6">
    </business-order-label>
  </div>
  @if (ba.status !== 0) {
    <ev-file-button
      [url]="'/api/v1/workflow/business/order/pdf/' + ba.id + '/' + ba.index+ '/'"
      [link]="true">
      <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
    </ev-file-button>
  }
</td>
<td>
  @if (!ba.is_express) {
    <span>{{ ba.work_days }} AT</span>
  }
  @if (ba.is_express) {
    <span class="label label-purple marginless">{{ ba.work_days }} AT</span>
  }
</td>
<td>
  <ev-status-label [state]="ba.status" type="business_order_status"
  [additional]="ba.status === 1 ? ba.percent + '%' : null"></ev-status-label>
</td>
<td>
  {{ ba.current_step }}
  @if (ba.step_duration) {
    <span class="label" [ngClass]="ba.step_duration_label">{{ ba.step_duration }}</span>
  }
</td>
<td>
  <a uiSref="a.business_order.create" [uiParams]="{id: ba.workflow_id}">
    {{ ba.workflow_id }}
  </a>
</td>
<td>{{ ba.start_date }}</td>
<td>
  {{ ba.end_date }} / {{ ba.end_week }}
</td>
<td class="align-right">
  {{ ba.quantity|money }}
</td>
<td class="align-right">
  {{ ba.quantity_ba|money }}
</td>
<td class="align-right">
  ({{ba.utilize_quantity|money}})
</td>
<td class="align-right">{{ ba.good_piece|money }}</td>
<td style="min-width: 60px;">{{ba.lp_type ?? '-'}}</td>
<td style="min-width: 60px;">{{ba.hdi_type ?? '-'}}</td>
<td>
  @switch (materialStatus) {
    @case ('button') {
      <div>
        <button type="button"
          class="btn btn-sm"
          [disabled]="!('ba.material.edit'|HasPerm)"
          [ngClass]="materialButtonStatus"
          (click)="openMaterialSelectModal()">
          {{ ba.material_planning_article_names.length > 0 ? ba.material_planning_article_names[0] : 'Zuordnungsfehler' }}
        </button>
        @if (!!ba.material_customer_specification) {
          <div style="padding: 10px 0 0;">
            <div class="label label-danger red_alert" style="margin: 0;">
              <i class="fa fa-exclamation-triangle"></i>&nbsp;Materialvorgabe
            </div>
          </div>
        }
      </div>
    }
    @case ('selected') {
      <div>
        {{ ba.material_planning_article_names.length > 0 ? ba.material_planning_article_names[0] : 'Standard FR4' }}
      </div>
    }
    @case ('booked') {
      <div>
        {{ ba.applied_material }}
      </div>
    }
    @case ('china') {
      <div>
        CN Artikel
      </div>
    }
    @default {
      <div>
        Standard FR4
      </div>
    }
  }
</td>
<td><a uiSref="a.article.workflow.detail" [uiParams]="{id:ba.oa_nr}">{{ ba.sds_nr }}</a></td>
<td>{{ ba.kd_art_nr }}</td>
<td>
  <a uiSref="a.crm.customer.detail" [uiParams]="{ id: ba.customer_id }">
    {{ ba.customer_id }} - {{ ba.customer }}
  </a>
</td>
<td [title]="ba.date_created_with_time + ' - ' + ba.created_username">{{ ba.date_created }}</td>
<td>
  @if (ba.status <= 1 && ('business_order.storno'|HasPerm)) {
    <button type="button"
      class="btn btn-sm btn-danger"
      (click)="storno()"
      >
      Stornieren
    </button>
  }
</td>
<td>
  @if (ba.status === 0 && ('ba.start'|HasPerm)) {
    <button type="button"
      class="btn btn-sm btn-success"
      (click)="startOrder()"
      >
      Start
    </button>
  }
</td>
